const API_BASE_URL =
  process.env.REACT_APP_API_GATEWAY_URL ||
  "https://ayq0vbo05e.execute-api.eu-central-1.amazonaws.com/PROD";

export async function getSignedUrlForFile(key) {
  if (!key) {
    throw new Error("S3 key mancante");
  }

  const cleanApiBaseUrl = API_BASE_URL.replace(/\/+$/, "");

  const response = await fetch(
    `${cleanApiBaseUrl}/s3url?key=${encodeURIComponent(key)}&op=get`,
    { cache: "no-store" }
  );

  if (!response.ok) {
    throw new Error(`Errore signed URL: ${response.status}`);
  }

  const data = await response.json();

  if (!data || !data.url) {
    throw new Error("La API non ha restituito data.url");
  }

  return data.url;
}

// Opens the tab synchronously with the click so popup blockers allow it,
// then redirects it once the signed URL is available.
export async function openS3Document(event, key) {
  event.preventDefault();

  if (!key) {
    console.error("S3 key mancante");
    alert("Documento non disponibile.");
    return;
  }

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Il browser ha bloccato l'apertura della nuova scheda.");
    return;
  }

  try {
    newTab.document.write("Caricamento documento...");
    newTab.document.close();
    newTab.opener = null;

    const signedUrl = await getSignedUrlForFile(key);
    newTab.location.replace(signedUrl);
  } catch (error) {
    console.error("Errore apertura documento:", key, error);
    newTab.close();
    alert("Documento non disponibile. Riprova più tardi.");
  }
}
